import {
  type ExtensionsScanResult,
  type FixExtensionsRequest,
  type Job,
  extensionsScanResultSchema,
  jobSchema,
} from '@xphoto/shared';
import { ApiError } from '../gallery/api';
import { LONG_TIMEOUT_MS, apiFetch } from '../lib/http';

/**
 * Client typé de la CORRECTION DES EXTENSIONS (« un vrai JPEG nommé .png »). Les réponses
 * sont RE-PARSÉES via leur schéma partagé — « never trust the client », y compris soi-même.
 */

async function readJson(res: Response): Promise<unknown> {
  if (!res.ok) {
    let code = 'UNKNOWN';
    try {
      const body = (await res.json()) as { error?: { code?: string } };
      if (typeof body?.error?.code === 'string') code = body.error.code;
    } catch {
      /* corps non-JSON : code générique */
    }
    throw new ApiError(res.status, code);
  }
  return res.json();
}

/**
 * `POST …/extensions/scan` — compte les fichiers dont l'extension ne correspond pas au
 * contenu réel (+ échantillon `from → to`). LECTURE, synchrone.
 */
export async function scanExtensions(
  libraryId: string,
  folder?: string,
): Promise<ExtensionsScanResult> {
  const res = await apiFetch(`/api/libraries/${libraryId}/extensions/scan`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(folder !== undefined ? { folder } : {}),
    // Analyse SYNCHRONE de toute la bibliothèque (MIME vs extension) → plafond long.
    timeoutMs: LONG_TIMEOUT_MS,
  });
  return extensionsScanResultSchema.parse(await readJson(res));
}

/**
 * `POST …/extensions/fix` — enfile un job `rename_extensions` qui renomme les fichiers mal
 * étiquetés vers leur extension canonique. 409 `WRITE_DISABLED` si l'écriture est désactivée.
 */
export async function enqueueFixExtensions(
  libraryId: string,
  body: FixExtensionsRequest,
): Promise<Job> {
  const res = await apiFetch(`/api/libraries/${libraryId}/extensions/fix`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return jobSchema.parse(await readJson(res));
}
